import httpService from '../httpService';
import { AffiliateCodeCommunity } from '../../models/Affiliate.model';
import { RootState } from '../../redux/reducers';
import { store } from '../../redux/store';

async function getCurrentAffiliate() {
  const { selectedDashboard } = (store.getState() as RootState).application;
  return httpService.get(`/networks/dashboards/${selectedDashboard}/affiliate`)
    .then((res) => res.data);
}

async function getAffiliateByCode(code: string) {
  return httpService.get(`/networks/affiliate/${code}`)
    .then((res) => res.data);
}

async function createAffiliateCode(code: string) {
  const { selectedDashboard } = (store.getState() as RootState).application;
  return httpService.post(`/networks/dashboards/${selectedDashboard}/affiliate`, { code })
    .then((res) => res.data);
}

async function getReferredCommunities(): Promise<AffiliateCodeCommunity[]> {
  const { selectedDashboard } = (store.getState() as RootState).application;
  return httpService.get(`/networks/dashboards/${selectedDashboard}/affiliate/reffered`)
    .then((res) => res.data);
}

async function getAffiliateLeaderboard() {
  return httpService.get('/networks/leaderboards/affiliate')
    .then((res) => res.data);
}

export {
  getCurrentAffiliate,
  getAffiliateByCode,
  createAffiliateCode,
  getReferredCommunities,
  getAffiliateLeaderboard
};